class StickyAtc extends HTMLElement {
    constructor() {
        super();
        this.stickyAtcElm = document.querySelector(".sticky-atc");
        this.stickyAtcBtn = document.querySelector(".cart-button.sticky-atc-btn");
        this.productSlider = document.querySelector(".slider-container");
        this.stickySelectedOtp = document.querySelector(".sticky-atc-recharge-selected");
        this.currentAtcBtn = document.querySelector(".cart-button");
        this.rechargeInputs = document.querySelectorAll(".label-and-button-container input");

        this.stickyRechargeTextEl = document.querySelector(".recharge-selected-option");
        this.stickyRechargeDiscount = document.querySelector(".sticky-act-price-product-price");
        this.stickyRechargePrice = document.querySelector(".sticky-act-price-discount-price");

        this.priceObserver = new MutationObserver(this.handlePriceChange.bind(this));
    }

    connectedCallback() {
        if (!document.querySelector(".label-and-button-container input:checked")) return;

        this.loadStickyAtcValues();

        document.addEventListener("scroll", this.handleScroll.bind(this));
        this.stickySelectedOtp.addEventListener("click", this.scrollToSlider.bind(this));
        this.stickyAtcBtn.addEventListener("click", () => this.currentAtcBtn.click());

        this.rechargeInputs.forEach(input => 
            input.addEventListener("change", this.loadStickyAtcValues.bind(this))
        );
    }

    handleScroll() {
        this.stickyAtcElm.style.display = window.scrollY >= 1000 ? "block" : "none";
    }

    scrollToSlider() {
        this.productSlider.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    loadStickyAtcValues() {
        const checkedRechargeInput = document.querySelector(".label-and-button-container input:checked");
        if (!checkedRechargeInput) return;

        const parentRechargeInput = checkedRechargeInput.closest(".label-and-button-container");
        if (!parentRechargeInput) return;

        const rechargeTextValue = parentRechargeInput.lastElementChild;
        const rechargePriceContainer = parentRechargeInput.nextElementSibling;

        if (!rechargePriceContainer) return;

        
        const rechargeRegularPrice = rechargePriceContainer.querySelector("span:not(.hide)");
        const rechargeTotalPrice = rechargePriceContainer.querySelector("span[data-smartrr-subscribe-price]");
        this.observePriceChanges(rechargeRegularPrice, rechargeTotalPrice);

        if (rechargeTextValue && rechargeRegularPrice && rechargeTotalPrice) {
            const validateTextPrice = rechargeRegularPrice.textContent.trim() === rechargeTotalPrice.textContent.trim() || rechargeRegularPrice.textContent.trim() == "$INVALID" ? "" : rechargeRegularPrice.textContent.trim();
            
            this.stickyRechargeTextEl.textContent = rechargeTextValue.textContent.trim();
            this.stickyRechargeDiscount.textContent = validateTextPrice;
            this.stickyRechargePrice.textContent = rechargeTotalPrice.textContent.trim();

            this.observePriceChanges(rechargeRegularPrice, rechargeTotalPrice);
        }
    }

    observePriceChanges(rechargeRegularPrice, rechargeTotalPrice) {
        this.priceObserver.disconnect();

        [rechargeRegularPrice, rechargeTotalPrice].forEach(el => {
            if (el) this.priceObserver.observe(el, { childList: true, subtree: true });
        });
    }

    handlePriceChange(mutations) {
        mutations.forEach(mutation => { 
            if (mutation.target.matches("span[data-smartrr-subscribe-price]")) {
                const validRegularPrice = mutation.target.parentElement.children[1].textContent.trim();
                const validComparePrice = mutation.target.parentElement.children[0].textContent.trim() === "$INVALID" ? "" : mutation.target.parentElement.children[0].textContent.trim();
                
                this.stickyRechargeDiscount.textContent = validRegularPrice || validComparePrice; //for crossed out price value
                this.stickyRechargePrice.textContent = mutation.target.textContent.trim(); //for total price value
            } 
        });
    }
}

customElements.define("sticky-atc", StickyAtc);